import Icon, { Popconfirm } from "./Icon";
Icon.Popconfirm = Popconfirm;
export default Icon;